export default __webpack_public_path__ + "static/media/683.45c30925.png";